import Select from "react-select";
import PropTypes from 'prop-types';

 function DropDown({options , setCategory ,isDisabled = false}) {
    //console.log("props",options.filter(opt => opt.value ===31)[0]);

    //const defValue = .optionsfilter(opt => opt.value ===31)[0];
    const defValue = options[0];

    console.log("defValue",defValue);
    //setCategory(defValue);


    const style = {
        control: (baseStyles, state) => ({
          ...baseStyles,
          backgroundColor: "white",
          width: "100%",
          height: "40px",
          color: "black",
          minHeight: "40px",
          paddingLeft: "5px",
          // This line disable the blue border
          boxShadow: state.isFocused ? 0 : 0,
          borderRadius: state.isSelected ? "0" : "10px",
          fontSize: "14px",
          "&:hover": {
            cursor: "pointer",
          },
          outline: "none",
        }),
        menu: (base) => ({ ...base, marginTop: "0px" }),
        menuList: (base) => ({ ...base, padding: "0" }),
        option: (provided, state) => ({
          ...provided,
          backgroundColor: state.isSelected ? "#FFDEDA" : "white",
          color: "black",
          fontSize: "14px",
          "&:hover": {
            backgroundColor: "#FFDEDA",
            // #dddddd
          },
        }),
        indicatorSeparator: (base) => ({
          ...base,
          display: "none",
        }),
        dropdownIndicator: (base, state) => ({
          ...base,
          color: "black",
          transform: state.selectProps.menuIsOpen ? "rotate(-180deg)" : "rotate(0)",
          transition: "250ms",
        }),
      };

  return (
    <Select
        className=" select"
        name="sellist1"
        options={options}
        //defaultValue={defaultValue === 0 ? options[0] : options.filter(opt => opt.value === defaultValue)}
        defaultValue={defValue}
        isDisabled={isDisabled}
        placeholder="Choose"
        onChange={setCategory}
        styles={style}
    ></Select>
    );
}

DropDown.propTypes = {
    options: PropTypes.array,
    setCategory : PropTypes.func ,
    isDisabled : PropTypes.bool,
    defaultValue : PropTypes.number,
  };

  export default DropDown;